import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

export default function PartnersSection({ onPartnerClick }) {
  return (
    <section id="partners" className="px-6 py-12 md:py-16">
      <div className="mx-auto max-w-5xl rounded-[2.5rem] border border-[#C89B3C]/25 bg-[#F8FAF9] p-6 text-center md:p-10">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#C89B3C]">
          Partners
        </p>
        <h2 className="mx-auto max-w-3xl text-3xl font-semibold tracking-tight text-[#063B30] sm:text-4xl md:text-5xl">
          Let&rsquo;s build the future of student guidance together.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-gray-600 md:text-lg">
          We welcome partnerships with counsellors, tutors, schools, colleges, universities,
          assessment providers, training companies, and education ecosystem partners.
        </p>
        <Button
          onClick={onPartnerClick}
          className="mt-7 rounded-full bg-[#0B5D4B] px-8 py-6 text-base text-white hover:bg-[#063B30]"
          data-testid="partners-cta-btn"
        >
          Partner With Crescet <ArrowRight className="ml-2" size={18} />
        </Button>
      </div>
    </section>
  );
}
